import {createAction, props} from '@ngrx/store';
import {MappedHttpErrorResponse} from '@adnova/jf-ng-components';
import {NewsDtoExtended} from '../../modules/interfaces/news-extended.interface';
import {PageableDTO} from '../../openapi/agrarinformationen-openapi';


export class NewsEntitiesActions {

  private static readonly prefix = '[News Entities] ';

  public static readNews = createAction(
    this.prefix + 'Read news.',
    props<{pageableDto?: PageableDTO}>()
  );

  public static readNewsSuccess = createAction(
    this.prefix + 'Read news successfully.',
    props<{
      newsDtos: NewsDtoExtended[],
      pageIndex: number,
      totalElements: number
    }>()
  );

  public static readNewsFailure = createAction(
    this.prefix + 'Read news failed.',
    props<{error: MappedHttpErrorResponse}>()
  );

  public static getNewsById = createAction(
    this.prefix + 'Read news by specific ID.',
    props<{newsId: number}>()
  );

  public static getNewsByIdSuccess = createAction(
    this.prefix + 'Read news successfully by specific ID.',
    props<{newsDto: NewsDtoExtended}>()
  );

  public static getNewsByIdFailure = createAction(
    this.prefix + 'Read news failed by specific ID.',
    props<{error: MappedHttpErrorResponse}>()
  );

}
